module.exports = __webpack_public_path__ + "static/media/S4C2.ab2af610.svg";